import React from "react";
import { motion } from "framer-motion";
import { FaBolt, FaChartLine, FaHeadset, FaShieldAlt } from "react-icons/fa";

const features = [
    {
        id: "fast-delivery",
        title: "Fast Delivery",
        description:
            "Launch websites, applications, and digital solutions quickly with an efficient development process and agile execution.",
        icon: <FaBolt />,
    },
    {
        id: "reliable-solutions",
        title: "Reliable Solutions",
        description:
            "Build secure, scalable, and performance-driven platforms designed to support long-term business growth.",
        icon: <FaShieldAlt />,
    },
    {
        id: "growth-focused",
        title: "Growth Focused",
        description:
            "Every service and software solution is designed to improve engagement, streamline operations, and accelerate growth.",
        icon: <FaChartLine />,
    },
    {
        id: "dedicated-support",
        title: "Dedicated Support",
        description:
            "Receive continuous assistance, maintenance, and expert guidance throughout your digital transformation journey.",
        icon: <FaHeadset />,
    },
];

export const WhyChooseHonestiSection = () => (
    <section className="premium-section why-choose-honesti">
        <div className="premium-section-inner">
            <div className="why-choose-honesti__header">
                <h3>Why Businesses Choose Honesti Digital</h3>
                <p className="why-choose-honesti__subtitle">
                    Supporting business growth through reliable technology, automation, and customer-focused solutions.
                </p>
            </div>

            <div className="why-choose-honesti__grid">
                {features.map((feature, index) => (
                    <motion.article
                        key={feature.id}
                        className="why-choose-honesti__card"
                        initial={{ opacity: 0, y: 14 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.25 }}
                        transition={{ duration: 0.4, delay: index * 0.06 }}
                    >
                        <span className="why-choose-honesti__icon">{feature.icon}</span>
                        <h4 className="why-choose-honesti__title">{feature.title}</h4>
                        <p className="why-choose-honesti__desc">{feature.description}</p>
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);
